var _symbol, _symbol2, _symbol3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNedbankLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 319.374388,
    viewBox: "0 0 26.513453 27.060538",
    width: 313.112146,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    overflow: "visible"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible"
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    overflow: "visible"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-226.77638 -97.458654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m234.24948 97.590946-7.34081 4.841044v17.11248l7.34081 4.84243 5.85667-3.96048 5.8663 3.96048 7.18509-4.85069v-17.09457l-7.18509-4.850694-5.8663 3.959104zm0 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.24121 114.8743 4.69222 3.22599-4.69222 3.22736zm17.59755-11.73124-5.86631-3.96048-5.8663 3.96048-5.86494-3.96048-6.01238 3.96048v15.69173l6.01238 3.9591 5.86494-3.9591 5.8663 3.9591 5.86631-3.9591zm-5.86631 5.42534v-7.91821l4.54615 3.07854v14.22549l-21.11706-14.07804 4.83967-3.22599zm0 0",
    fill: "#00633a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35277779 0 0 .35277779 62.844951 80.078836)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#00633a",
    height: "100%",
    width: "100%",
    x: 339.71179,
    xlinkHref: "#a",
    y: 242.7408
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00633a",
    height: "100%",
    width: "100%",
    x: 96.655182,
    xlinkHref: "#a",
    y: 273.4353
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00633a",
    height: "100%",
    width: "100%",
    x: 327.56641,
    xlinkHref: "#a",
    y: 273.4353
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    x: 276.65591,
    xlinkHref: "#b",
    y: 687.93652
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    x: 98.703903,
    xlinkHref: "#c",
    y: 711.93652
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNedbankLogo);
export default __webpack_public_path__ + "static/media/Nedbank_logo.ca84b0eea5ac8004b723faef5ca0c2af.svg";
export { ForwardRef as ReactComponent };